import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-hippacomponent',
  imports: [TranslatePipe],
  templateUrl: './hippacomponent.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './hippacomponent.scss'
})
export class HIPPAComponent {

}
